module.exports = __webpack_public_path__ + "media/images/pepsi_digin_brunch_lv/shape-6-ca41c3043403e10a93039865d1859fdf.png";